"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDetailsPage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var main_1 = require("../../../reducers/slices/main");
var react_use_clipboard_1 = __importDefault(require("react-use-clipboard"));
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var get_user_1 = require("../../../api/calls/users/v3/get_user");
var create_user_1 = require("../../../api/calls/users/v3/create_user");
var delete_user_1 = require("../../../api/calls/users/v3/delete_user");
var update_user_1 = require("../../../api/calls/users/v3/update_user");
var admin_autogen_user_password_1 = require("../../../api/calls/users/v3/admin_autogen_user_password");
var UserDetailsPage = function (props) {
    var _a;
    var onSuccess = props.onSuccess;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var params = (0, react_router_dom_1.useParams)();
    var _b = params.user_entity_id, user_entity_id = _b === void 0 ? "" : _b;
    var selectedClient = (0, react_redux_1.useSelector)(function (state) { return state.clientState; }).selectedClient;
    var _c = (0, react_1.useState)(false), isBusy = _c[0], setIsBusy = _c[1];
    var _d = (0, react_1.useState)(""), nakedPassword = _d[0], setNakedPassword = _d[1];
    var _e = (0, react_1.useState)({
        name: "",
        surname: "",
        cell_phone: {
            calling_code: "",
            country_code: "ZA",
            number: "",
        },
        device: {
            firebase_token: "",
        },
        email: "",
        id_number: "",
        address: "",
        get_communication: false,
        agrees_terms_and_conditions: true,
    }), user = _e[0], setUser = _e[1];
    // const [firstName, setFirstName] = useState("");
    // const [lastName, setLastName] = useState("");
    // const [extension, setExtension] = useState("");
    // const [phoneNumber, setPhoneNumber] = useState("");
    // const [email, setEmail] = useState("");
    var _f = (0, react_1.useState)(""), firstNameErrorText = _f[0], setFirstNameErrorText = _f[1];
    var _g = (0, react_1.useState)(""), lastNameErrorText = _g[0], setLastNameErrorText = _g[1];
    var _h = (0, react_1.useState)(""), phoneNumberErrorText = _h[0], setPhoneNumberErrorText = _h[1];
    var _j = (0, react_1.useState)(""), emailErrorText = _j[0], setEmailErrorText = _j[1];
    var _k = (0, react_1.useState)(false), isLoading = _k[0], setIsLoading = _k[1];
    var _l = (0, react_use_clipboard_1.default)(nakedPassword, {
        successDuration: 1000,
    }), isNakedPasswordCopied = _l[0], copyNakedPassword = _l[1];
    (0, react_1.useEffect)(function () {
        if (!(selectedClient === null || selectedClient === void 0 ? void 0 : selectedClient.entity_id)) {
            navigate("/console/users");
        }
    }, []);
    (0, react_1.useEffect)(function () {
        setIsLoading(true);
        if (user_entity_id) {
            (0, get_user_1.get_user)({ user_entity_id: user_entity_id }).then(function (response) {
                if (response.data.success) {
                    console.log("users response.data.content", response.data.content);
                    var user_1 = response.data.content;
                    // setFirstName(user.name);
                    // setLastName(user.surname);
                    // setPhoneNumber(user.cell_number);
                    // setEmail(user.email);
                    setUser(user_1);
                }
                else {
                    dispatch((0, main_1.setMessageModal)({ title: "Users", messages: [response.data.message] }));
                }
                setIsLoading(false);
            });
        }
    }, [user_entity_id]);
    var onFieldChange = function (field, value) {
        var _a;
        setUser(__assign(__assign({}, user), (_a = {}, _a[field] = value, _a)));
    };
    var validate = function () {
        var errorCount = 0;
        setFirstNameErrorText("");
        setLastNameErrorText("");
        setPhoneNumberErrorText("");
        setEmailErrorText("");
        if (!user.name.length) {
            setFirstNameErrorText("First name is required");
            errorCount++;
        }
        if (!user.surname.length) {
            setLastNameErrorText("Last name is required");
            errorCount++;
        }
        if (!user.cell_phone.number.length) {
            setPhoneNumberErrorText("Phone number is required");
            errorCount++;
        }
        if (!user.email.length) {
            setEmailErrorText("Email is required");
            errorCount++;
        }
        if (errorCount > 0) {
            return false;
        }
        else {
            return true;
        }
    };
    return (react_1.default.createElement("div", { className: "flex flex-col gap-4" }, user ? (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
        nakedPassword && (react_1.default.createElement("div", { className: "p-4 rounded-lg" },
            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Generated Password:", size: "large", bold: true, textColor: "text-black" }),
            react_1.default.createElement("div", { className: "flex flex-row gap-4 items-center" },
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: nakedPassword, size: "medium", bold: true, textColor: "text-black" }),
                react_1.default.createElement(doshx_controls_web_1.IconButtonControl, { icon: isNakedPasswordCopied ? pro_light_svg_icons_1.faCheck : pro_light_svg_icons_1.faCopy, backgroundColor: isNakedPasswordCopied ? "bg-green-400" : "bg-orange-400", onClick: function () {
                        copyNakedPassword();
                    } }),
                react_1.default.createElement("div", { className: "text-sm" }, "Please note that this password is only visible this ONE time.")))),
        react_1.default.createElement("div", { className: "flex" }, (user === null || user === void 0 ? void 0 : user.client_entity_id) ? (react_1.default.createElement("div", { className: "flex flex-row gap-4" },
            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Update", loading: isBusy, size: "small", onClick: function () {
                    if (validate()) {
                        (0, update_user_1.update_user)({
                            entity_id: user.entity_id,
                            entity: {
                                name: user.name,
                                surname: user.surname,
                                cell_phone: {
                                    calling_code: user.cell_phone.calling_code,
                                    country_code: user.cell_phone.country_code,
                                    number: user.cell_phone.number,
                                },
                                email: user.email.toLocaleLowerCase().trim(),
                                get_communication: user.get_communication,
                                agrees_terms_and_conditions: user.agrees_terms_and_conditions,
                                id_number: user.id_number,
                                address: user.address,
                            },
                        }).then(function (response) {
                            if (response.data.success) {
                                dispatch((0, main_1.setMessageModal)({ title: "Users", messages: ["User updated successfully."] }));
                                setUser(response.data.content.user);
                                if (onSuccess) {
                                    onSuccess();
                                }
                            }
                            else {
                                dispatch((0, main_1.setMessageModal)({ title: "Users", messages: [response.data.message] }));
                            }
                        });
                    }
                } }),
            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Delete", loading: isBusy, size: "small", backgroundColor: "bg-red-500", onClick: function () {
                    dispatch((0, main_1.setMessageModal)({
                        title: "Delete User",
                        messages: ["Are you sure you want to delete this user?"],
                        buttons: "delete",
                        onConfirm: function () {
                            (0, delete_user_1.delete_user)({ user_entity_id: user.entity_id }).then(function (response) {
                                if (response.data.success) {
                                    navigate("/console/users");
                                    dispatch((0, main_1.setMessageModal)(null));
                                    if (onSuccess) {
                                        onSuccess();
                                    }
                                }
                                else {
                                    dispatch((0, main_1.setMessageModal)({ title: "Users", messages: [response.data.message] }));
                                }
                            });
                        },
                    }));
                } }),
            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Re-Gen User's Password", loading: isBusy, size: "small", backgroundColor: "bg-orange-500", onClick: function () {
                    dispatch((0, main_1.setMessageModal)({
                        title: "Are you sure?",
                        messages: ["Are you sure you want to re-generate this user's password?"],
                        buttons: "yesNo",
                        onConfirm: function () {
                            (0, admin_autogen_user_password_1.admin_autogen_user_password)({
                                user_entity_id: user.entity_id,
                            }).then(function (response) {
                                if (response.data.success) {
                                    setNakedPassword(response.data.content);
                                    dispatch((0, main_1.setMessageModal)(null));
                                }
                                else {
                                    dispatch((0, main_1.setMessageModal)({ title: "Users", messages: [response.data.message] }));
                                }
                            });
                        },
                    }));
                } }),
            react_1.default.createElement("div", { className: "flex" },
                react_1.default.createElement("div", { className: " p-2 text-white rounded-lg cursor-pointer", onClick: function () { } }),
                react_1.default.createElement("div", { className: "" })))) : (react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Create", loading: isBusy, size: "small", onClick: function () {
                if (validate()) {
                    (0, create_user_1.create_user)({
                        client_entity_id: selectedClient.entity_id,
                        name: user.name,
                        surname: user.surname,
                        cell_phone: {
                            calling_code: user.cell_phone.calling_code,
                            country_code: user.cell_phone.country_code,
                            number: user.cell_phone.number,
                        },
                        email: user.email.toLocaleLowerCase().trim(),
                        get_communication: user.get_communication,
                        agrees_terms_and_conditions: user.agrees_terms_and_conditions,
                        // device: {
                        //   firebase_token: user.device.firebase_token,
                        // },
                    }).then(function (response) {
                        setIsBusy(false);
                        if (response.data.success) {
                            var naked_password = response.data.content.naked_password;
                            setNakedPassword(naked_password);
                            setUser(response.data.content);
                            if (onSuccess) {
                                onSuccess();
                            }
                        }
                        else {
                            dispatch((0, main_1.setMessageModal)({ title: "Users", messages: [response.data.message] }));
                        }
                    });
                    // create_user_for_client({
                    //   client_id: selectedClient._id,
                    //   name: firstName,
                    //   surname: lastName,
                    //   cell_country_code: extension,
                    //   cell_number: phoneNumber,
                    //   email: email.toLocaleLowerCase().trim(),
                    // }).then((response) => {
                    //   setIsBusy(false);
                    //   if (response.data.success) {
                    //     const { naked_password, user } = response.data.content.user;
                    //     setNakedPassword(naked_password);
                    //     if (refreshUsers) {
                    //       refreshUsers();
                    //     }
                    //   } else {
                    //     dispatch(setMessageModal({ title: "Users", messages: [response.data.message] }));
                    //   }
                    // });
                }
            } }))),
        react_1.default.createElement("div", { className: "flex flex-col gap-4" },
            react_1.default.createElement("div", { className: "flex flex-row gap-4" },
                react_1.default.createElement("div", { className: "flex-1 flex flex-col gap-4" },
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "First Name", value: user.name, onChange: function (v) {
                            onFieldChange("name", v);
                        }, errorText: firstNameErrorText }),
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Last Name", value: user.surname, onChange: function (v) {
                            onFieldChange("surname", v);
                        }, errorText: lastNameErrorText }),
                    react_1.default.createElement(doshx_controls_web_1.PhoneInputControl, { label: "Phone Number", value: user.cell_phone.number, defaultCountryCode: user.cell_phone.country_code, onExtensionChange: function (ext, code) {
                            setUser(__assign(__assign({}, user), { cell_phone: __assign(__assign({}, user.cell_phone), { calling_code: ext, country_code: code }) }));
                        }, onChange: function (v) {
                            setUser(__assign(__assign({}, user), { cell_phone: __assign(__assign({}, user.cell_phone), { number: v }) }));
                        }, errorText: phoneNumberErrorText }),
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Email", value: user.email, onChange: function (v) {
                            onFieldChange("email", v);
                        }, errorText: emailErrorText })),
                (user === null || user === void 0 ? void 0 : user.entity_id) && (react_1.default.createElement("div", { className: "flex-1 flex flex-col gap-4" },
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "ID Number", value: user.id_number, onChange: function (v) {
                            onFieldChange("id_number", v);
                        }, errorText: "" }),
                    react_1.default.createElement(doshx_controls_web_1.TextAreaControl, { label: "Address", value: user.address, onChange: function (v) {
                            onFieldChange("address", v);
                        }, errorText: "" })))),
            react_1.default.createElement("div", { className: "flex-1 flex flex-row gap-8" },
                react_1.default.createElement(doshx_controls_web_1.CheckboxControl, { label: "Get Communication?" //
                    , value: user.get_communication, disabled: user.entity_id ? true : false, onChange: function (v) { return onFieldChange("get_communication", v); } }),
                react_1.default.createElement(doshx_controls_web_1.CheckboxControl, { label: "Agrees To Terms & Conditions?", value: user.agrees_terms_and_conditions, disabled: user.entity_id ? true : false, onChange: function (v) { return onFieldChange("agrees_terms_and_conditions", v); } })),
            react_1.default.createElement("div", { className: "" }, ((_a = user.device) === null || _a === void 0 ? void 0 : _a.firebase_token) && (react_1.default.createElement("div", { className: "flex gap-2" },
                react_1.default.createElement("span", { className: "text-xl font-bold" }, "Firebase Token:"),
                react_1.default.createElement("span", { className: "text-lg" }, user.device.firebase_token))))))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(doshx_controls_web_1.CircularLoaderControl, { size: "small" })))));
};
exports.UserDetailsPage = UserDetailsPage;
